import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Academia } from '../model/academia.model';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AcademiaService {
  private apiUrl =  `${environment.apiUrl}/api/academias`; 
  constructor(private http: HttpClient) {}

  private manejarError(error: HttpErrorResponse): Observable<never> {
    let mensaje = 'Ocurrió un error inesperado';
    if (error.error?.message) {
      mensaje = error.error.message;
    }
    return throwError(() => new Error(mensaje));
  }

  // Obtener todas las academias
  getAcademias(): Observable<Academia[]> {
    return this.http.get<Academia[]>(this.apiUrl, { withCredentials: true })
      .pipe(catchError(this.manejarError));
  }

  // Actualizar academia
  updateAcademia(id: number, academia: Academia): Observable<Academia> {
    return this.http.put<Academia>(`${this.apiUrl}/${id}`, academia, { withCredentials: true })
      .pipe(catchError(this.manejarError));
  }

  // Crear una nueva academia
  createAcademia(academia: Academia): Observable<Academia> {
    return this.http.post<Academia>(this.apiUrl, academia, { withCredentials: true })
      .pipe(catchError(this.manejarError));
  }

  // Eliminar academia
  deleteAcademia(id: number): Observable<void> {
    return this.http.delete<void>(`${this.apiUrl}/${id}`, { withCredentials: true })
      .pipe(catchError(this.manejarError));
  }

  // Obtener academias filtradas por cédula
  getAcademiasByCedula(cedula: string): Observable<Academia[]> {
    return this.http.get<Academia[]>(`${this.apiUrl}/cedula/${cedula}`, { withCredentials: true })
      .pipe(catchError(this.manejarError));
  }
}
